import { API_KEY_SECRET_PREFIX } from './generate-api-key-secret';

export const API_KEY_HINT_LENGTH = API_KEY_SECRET_PREFIX.length + 4;

export function generateApiKeyHint(token: string): string {
  return token.substring(0, API_KEY_HINT_LENGTH);
}
